module.exports = __webpack_public_path__ + "static/media/AUD_2_1539694341.079df6ab.mp3";